export class PlasmError extends Error {
    constructor(data) {
        super(data.msg || data.code);
        this.code = data.code;
    }
}
